import { render } from "./MenuMobileMock.vue?vue&type=template&id=6e44ef57&scoped=true"
import script from "./MenuMobileMock.vue?vue&type=script&lang=js"
export * from "./MenuMobileMock.vue?vue&type=script&lang=js"

import "./MenuMobileMock.vue?vue&type=style&index=0&id=6e44ef57&lang=scss&scoped=true"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e44ef57"]])

export default __exports__